import script from "./TabsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsSection.vue?vue&type=script&setup=true&lang=js"

import "./TabsSection.vue?vue&type=style&index=0&id=c8a5dab2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a5dab2"]])

export default __exports__